import type { validation as validationEn } from "../en/validation";

export const validation: typeof validationEn = {
  required: "Toto pole je povinné",
  invalidNumber: "Zadejte platné číslo",
  min: "Musí být alespoň {{n}}",
  max: "Musí být nejvýše {{n}}",
  maxLength: "Maximálně {{n}} znaků",
  minLength: "Minimálně {{n}} znaků",
  invalidOption: "Vyberte platnou možnost",
  invalidUrl: "Zadejte platnou URL adresu",
  invalidEmail: "Zadejte platný e-mail",
  invalidValue: "Neplatná hodnota",
  coordinatesFormat:
    "Zadejte dvě čísla s desetinnou tečkou oddělená čárkou, např. „-8.79203, 115.22704“",
  coordinatesRange: "Zeměpisná šířka musí být mezi -90 a 90 a délka mezi -180 a 180",
  fixHighlighted: "Uložení se nezdařilo — opravte prosím tato pole:",
  checkForm: "Zkontrolujte prosím formulář — některá data nejsou platná.",
  network: "Nelze se připojit k serveru. Zkontrolujte připojení k internetu.",
  sessionExpired: "Vaše přihlášení vypršelo. Přihlaste se prosím znovu.",
  forbidden: "K této akci nemáte oprávnění.",
  notFound: "Položka nebyla nalezena. Možná byla smazána.",
  server: "Něco se pokazilo na naší straně. Zkuste to prosím později.",
  unexpected: "Došlo k neočekávané chybě.",
};
